export interface IDiskStatus {
  letter: string;
  total: number;
  used: number;
}

export interface IHostInfo {
  processor: string | null;
  ram: string | null;
  video: string | null;
  disc: string | null;
  shell_version: string | null;
}

export enum EHostType {
  PC = 'PC',
  CONSOLE = 'CONSOLE',
  VR = 'VR',
  BILLIARD = 'BILLIARD',
  BOARD_GAME = 'BOARD_GAME',
  RACING_SIM = 'RACING_SIM',
}
export interface IHostCounters {
  active_window: string | null;
  disk_status: Array<IDiskStatus> | null;
}

export type THostStatus = 'FREE' | 'BUSY' | 'IN_SERVICE';

export interface IHostBooking {
  id: number;
  from: string;
  to: string;
  client?: {
    uuid: string;
    nickname: string;
  };
}

export enum EShellMode {
  NORMAL = 'NORMAL',
  DISABLED = 'DISABLED',
  HIGH_ACCESS = 'HIGH_ACCESS',
}
